import {useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import useShow from '../../../../hooks/useShow';
import {useTranslation} from 'react-i18next';
import MarketingPromotionSettings from './marketingPromotionSettings/marketingPromotionSettings';
import MarketingPromotionInsights from './marketingPromotionInsights/marketingPromotionInsights';
import MasterPixel from '../../../../component/masterPixel/MasterPixel';
import {useSelector} from 'react-redux';
import {hasMasterUserPermission} from '../../../../functions/permission';
import {MASTER_PERMISSIONS} from '../../../../config/masterPermissions';

export default function useMarketingPromotion(){   
    const [page, setPage] = useState('');
    const marketingPromotionsShow = useShow();
    const packageName = useSelector((state: any) => state.account?.title);
    const {t} = useTranslation('realtime');
    const navigate = useNavigate();

    // Check if user has AppPlus access permission
    const hasAppPlusAccess = hasMasterUserPermission(MASTER_PERMISSIONS.APP_PLUS_ACCESS);

    const promotionList = [
        // {
        //     title: t('settings'),
        //     text: 'settings',
        // },
        {
            title: t('ads'),
            text: 'ads',
            onClick: (item) => onListClick(item)
        },
        {
            title: t('masterPixel'),
            text: 'masterPixel',
            onClick: (item) => onListClick(item)
        },
        // Add AppPlus button if user has permission
        ...(hasAppPlusAccess ? [{
            title: 'באק אופיס',
            text: 'appPlus',
            onClick: () => navigate('/appPlus/dashboard')
        }] : []),
        {
            title: t('insights'),
            text: 'insights',
            onClick: (item) => onListClick(item)
        }
    ];
    const formRef=useRef(null);
    const body = {
        'settings':<MarketingPromotionSettings formRef={formRef}/>,
        'ads': <MarketingPromotionSettings formRef={formRef}/>,
        'insights': <MarketingPromotionInsights formRef={formRef}/>,
        'masterPixel': <MasterPixel/>
    };
    const onListClick = (item:any)=>{
        setPage(item.text);
        marketingPromotionsShow.open();
    };

    return {promotionList, onListClick, body, packageName, page, marketingPromotionsShow};
}